import { CopyButtonWithLabel } from '@/components/CopyButton';
import { useTranslation } from '@/i18n';
import classnames from 'classnames/bind';
import { FC, memo, useMemo } from 'react';
import styles from './styles.module.scss';

const cx = classnames.bind(styles);

type CopyLinkButtonProps = {
  detailPath?: string;
};

/**
 * `GetInvoiceReportViewersResponse` has no `share_url`, so the link is built
 * from the detail screen's own `detail_path` (origin + path) instead.
 * Same behavior as business_documents' CopyURLButton (shows "copied" for
 * only 2 seconds).
 */
export const CopyLinkButton: FC<CopyLinkButtonProps> = memo(
  ({ detailPath }) => {
    const { t } = useTranslation();
    const shareUrl = useMemo(
      () => (detailPath ? new URL(detailPath, location.origin).toString() : ''),
      [detailPath]
    );

    return (
      <CopyButtonWithLabel
        size='sm'
        isSecondary
        omitLeftIconPadding
        buttonContainerClassName={cx('button')}
        text={shareUrl}
        isDisabled={!shareUrl}
        copyLabel={t('invoice_report_share.copy_link')}
        copiedLabel={t('invoice_report_share.copy_link_copied')}
        resetMilliSecond={2000}
        testId='invoice-report-share-copy-link-button'
      />
    );
  }
);
CopyLinkButton.displayName = 'CopyLinkButton';
